'use client';

import { ElementRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = ({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
  ref?: React.RefObject<ElementRef<typeof TabsPrimitive.List> | null>;
}) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'bg-muted text-muted-foreground inline-flex h-10 items-center justify-center rounded-md p-1',
      className
    )}
    {...props}
  />
);
TabsList.displayName = TabsPrimitive.List.displayName || 'TabsList';

const TabsTrigger = ({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
  ref?: React.RefObject<ElementRef<typeof TabsPrimitive.Trigger> | null>;
}) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'hover:bg-muted/50 data-[state=active]:bg-background data-[state=active]:text-foreground focus-visible:ring-ring/70 inline-flex cursor-pointer items-center justify-center rounded-sm px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-xs',
      className
    )}
    {...props}
  />
);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName || 'TabsTrigger';

const TabsContent = ({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof TabsPrimitive.Content> & {
  ref?: React.RefObject<ElementRef<typeof TabsPrimitive.Content> | null>;
}) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'focus-visible:ring-ring/70 mt-2 focus-visible:ring-2 focus-visible:outline-hidden',
      className
    )}
    {...props}
  />
);
TabsContent.displayName = TabsPrimitive.Content.displayName || 'TabsContent';

export { Tabs, TabsList, TabsTrigger, TabsContent };
